import * as React from "react"

function PlayStoreSvg(props) {
    return (
        <svg
            id="PlayStoreSvgWarstwa_1"
            x={0}
            y={0}
            viewBox="0 0 135 40"
            xmlSpace="preserve"
            {...props}
        >
            <style>{".PlayStoreSvgst1{fill:#fff}.PlayStoreSvgst11{fill:#404040}"}</style>
            <path d="M130 40H5c-2.7 0-5-2.2-5-5V5c0-2.7 2.2-5 5-5h125c2.8 0 5 2.3 5 5v30c0 2.7-2.3 5-5 5" />
            <path
                d="M130 0H5C2.2 0 0 2.3 0 5v30c0 2.7 2.2 5 5 5h125c2.8 0 5-2.3 5-5V5c0-2.7-2.3-5-5-5m0 .8c2.3 0 4.2 1.9 4.2 4.2v30c0 2.3-1.9 4.2-4.2 4.2H5C2.7 39.2.8 37.3.8 35V5C.8 2.7 2.7.8 5 .8h125"
                fill="#a6a6a6"
            />
            <path
                className="PlayStoreSvgst1"
                d="M106.9 30h1.9V17.5h-1.9V30zm16.8-8l-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2zm-10.5 6.6c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.2 1.2-1.2 2-2.2 2zm.2-6.9c-1.4 0-2.7.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5zm-11.5 1.8h-2.7v-4.3h2.7c1.4 0 2.2 1.2 2.2 2.1-.1 1.1-.9 2.2-2.2 2.2zm-.1-6h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9zM77.4 28.6c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.3 1.1 2.3 2.6s-1 2.6-2.3 2.6zm2.2-5.9c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.8v.7zm3 7.3h1.9V17.5h-1.9V30zm4.7-4.1c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9l-3.8 1.6zm5.8-1.4c-.4-1-1.4-2.7-3.6-2.7s-4 1.7-4 4.3c0 2.4 1.8 4.3 4.2 4.3 1.9 0 3.1-1.2 3.5-1.9l-1.4-1c-.5.7-1.1 1.2-2.1 1.2s-1.6-.4-2.1-1.3l5.7-2.4-.2-.5zm-45.4-1.4v1.8H52c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8 0-2.7 2.1-4.8 4.7-4.8 1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6 0 3.6 3.1 6.6 6.7 6.6 2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1h-6.2zm11.1 5.5c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm0-6.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3zm9.3 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm0-6.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3z"
            />
            <defs>
                <path
                    id="PlayStoreSvgSVGID_1_"
                    d="M10.5 32.4c-.4-.4-.5-.9-.5-1.5v.1V8.9 9c0-.7.2-1.2.5-1.5L22.9 20 10.5 32.4M10 8.9v-.2.2m0-.1"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_2_">
                <use xlinkHref="#PlayStoreSvgSVGID_1_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_2_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_3_" d="M10 7.6h12.9v24.8H10z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_4_">
                    <use xlinkHref="#PlayStoreSvgSVGID_3_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_4_)">
                    <image
                        width={32}
                        height={55}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAH+AAACSAAAAvf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADgAIQMBIgACEQEDEQH/ xACWAAEBAQEBAQEAAAAAAAAAAAAABQIGAwEEAQADAQEAAAAAAAAAAAAAAAADBQYEAhAAAgIBBAEE AwAAAAAAAAAAAAEDBAUCEiIkNBETFQYjMxQRAAIBAgQGAwAAAAAAAAAAAAECAxByABHBM0GRsRKS c2FSshIAAQMCBgMBAAAAAAAAAAAAAQAQAhEDITFxwTJyQdESIv/aAAwDAQACEQMRAAAA7D8nyXvn auo+yB64LKiFLqSmsq35aKHsglsIMmrHbS7fjs4u3CKtgSBtN40aOO3CGn//2gAIAQIAAQUAhhj1 RuvF6Ff9TXErL8TXErbvae7af//aAAgBAwABBQC7esx2dGQtvWZBduJcy+u3EuZd2f1R+3uP/9oA CAEBAAEFAMhkddOX56U+elIs5LrlM75A2Vn2TO+Q2NlZ9kz3kNjZWfaM/wCS2NlV9o+wvstjZVfb PsEcmqy4ZxwzlWGdWz//2gAIAQICBj8AiTGpIR/PhoaI6FoaI6FoUpkjxyLf/9oACAEDAgY/ALkI XDGMZYCgUQbpxkPA9Nd7bKPYNd7bKPYNdr9V+tlHlyDf/9oACAEBAQY/AFRUDBl7syfnLG0vM42l 5nCRmJQHYLnmeJypHZqaw3r1FI7NTWG9eopHZqaw+xeopHZqaw+xP0KR2amsHsT9CkZRSw7OAJ4n G2/icbT+JxATG4AkTM9p+wp//9k="
                        transform="matrix(.48 0 0 -.48 8.546 33.44)"
                        overflow="visible"
                    />
                </g>
            </g>
            <defs>
                <path
                    id="PlayStoreSvgSVGID_5_"
                    d="M27 24.3l5-2.8c.5-.3.8-.6.9-.9-.2.3-.5.7-.9.9l-5 2.8m0-.2L22.9 20l4.1-4.1 5 2.8c.6.4 1 .8 1 1.3-.1.5-.4.9-1 1.3l-5 2.8"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_6_">
                <use xlinkHref="#PlayStoreSvgSVGID_5_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_6_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_7_" d="M22.9 15.9h10.2v8.4H22.9z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_8_">
                    <use xlinkHref="#PlayStoreSvgSVGID_7_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_8_)">
                    <image
                        width={28}
                        height={21}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG+AAAB5wAAAmn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABcAHwMBIgACEQEDEQH/ xACNAAACAgMAAAAAAAAAAAAAAAAABQMEAQIGAQEBAQEAAAAAAAAAAAAAAAACAwQFEAABBAIDAQAA AAAAAAAAAAADAAECBBMFETIUNBEAAQMBBgYDAAAAAAAAAAAAAQARAjIhQVFxkQMQMWHBEpJyEzMS AAEEAgMBAQAAAAAAAAAAAAEAEQISMQMhQRNRFP/aAAwDAQACEQMRAAAA7WDFLg7WFtQzrOGoBW7A Kj//2gAIAQIAAQUAvXLA7GrtHMa54c+u8eb/2gAIAQMAAQUAEIbjOOMYizYzZOP/2gAIAQEAAQUA uXJVnbaEdNsZuoleVfbdoqKH8OyE5JNWkmruoR4qf//aAAgBAgIGPwDZCGwxjFmDD4FOO2ZmBrcB hlwp+vtfi1GbCl+f1tTn0ZmcL//aAAgBAwIGPwCJMXJQMQ3KjWlenyheuel//9oACAEBAQY/AICM RLyfn0VA1KoGq+1rfElsltZHtxPwl3W20oxYGqQjhiv02/cKvb9wjFxTIO9l96//2Q=="
                        transform="matrix(.48 0 0 -.48 21.75 25.319)"
                        overflow="visible"
                    />
                </g>
            </g>
            <defs>
                <path
                    id="PlayStoreSvgSVGID_9_"
                    d="M11.4 32.9c-.3 0-.6-.1-.9-.3.2.1.5.3.9.3 0 0 .1 0 0 0 .1 0 0 0 0 0m0-.2c-.3 0-.6-.1-.9-.3L22.9 20l4.1 4.1-14.5 8.2c-.4.3-.8.4-1.1.4m-.9-.2"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_10_">
                <use xlinkHref="#PlayStoreSvgSVGID_9_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_10_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_11_" d="M10.4 20H27v12.9H10.4z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_12_">
                    <use xlinkHref="#PlayStoreSvgSVGID_11_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_12_)">
                    <image
                        width={40}
                        height={30}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHpAAACKgAAAsL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAKgMBIgACEQEDEQH/ xACfAAADAQEBAQAAAAAAAAAAAAAABQYDAQIEAQEAAwEBAAAAAAAAAAAAAAAAAgMEBQYQAAEDAwIF BQAAAAAAAAAAAAEAAwQCBQYSFBAgJTUWESExExURAAIAAgkDBQAAAAAAAAAAAAECAAMQEZGxkjNz BDQgMFEhMXESExIAAQIDBgcAAAAAAAAAAAAAAQACEBIyIBEhMWEDkSKCkrITNP/aAAwDAQACEQMR AAAAqfkXJodqrJX1C6udwV6pjUz1Q05917Xp3u4i3ZgDV5wAAA//2gAIAQIAAQUANRBLhX2HTX8n 1Xvo4//aAAgBAwABBQCPBYrZ/OjLYx9xENO31Uo1U7zj/9oACAEBAAEFALpkLNtk+Yxl5hGXl8ZR cnYkyFlndQEAgFaR1JZX3QBAIBWkdSWUMPOXIRZKEWQhGkK1sP03Hn//2gAIAQICBj8AhfrcjDqs f//aAAgBAwIGPwBj3NJLmgnmKpPcUNuUy+kvqOcwC2sRQFmOKGI+d3kLH//aAAgBAQEGPwAbd5LT CVD/AGUgD1r8/EcZ7RHHe0Rx3tES5CyHUzWCgkioV0DSW9uja6q30DSW9uja6i30Bklsw/JRWASP doynwmMp8JjKfCY2xaW4AmLWSp89j//Z"
                        transform="matrix(.48 0 0 -.48 9.262 33.904)"
                        overflow="visible"
                    />
                </g>
            </g>
            <defs>
                <path
                    id="PlayStoreSvgSVGID_13_"
                    d="M22.9 20L10.5 7.6c.2-.2.5-.3.9-.3.3 0 .7.1 1.1.3L27 15.9 22.9 20m4.2-4.2L12.5 7.5c-.4-.2-.8-.3-1.1-.3.3 0 .7.1 1.1.3l14.6 8.3M11.4 7.1"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_14_">
                <use xlinkHref="#PlayStoreSvgSVGID_13_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_14_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_15_" d="M10.5 7.1h16.6V20H10.5z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_16_">
                    <use xlinkHref="#PlayStoreSvgSVGID_15_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_16_)">
                    <image
                        width={40}
                        height={30}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHnAAACGwAAAqj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAKgMBIgACEQEDEQH/ xACbAAEBAQADAQAAAAAAAAAAAAAABgUBAgMEAQACAwEBAAAAAAAAAAAAAAAAAwECBAUGEAABAwIF BAMAAAAAAAAAAAADAAIEAQUQEhM0FiARIRRCJBURAAIABAYBBQAAAAAAAAAAAAECAJEDMxAgEUGx cjAhURKSExIBAAEBBgYDAAAAAAAAAAAAAQACIBExEjIDEEFhkSJigpI0/9oADAMBAAIRAxEAAACx 8Pjzk8DdYSE0GnKVcvnM/Rz4zcO6uT1q5eotqB/qAAA//9oACAECAAEFAHPdSuo5Z3ZX089l8cf/ 2gAIAQMAAQUAlXGSM/6ktUuEn1Zo3VkZHKjXelj/AP/aAAgBAQABBQCbdRwzcgCuQBXIAoF7EYyv u9xgb1X6v3sYG9V9GR06gTLRMtEygiLSZ1//2gAIAQICBj8ASYy/rHh8rH//2gAIAQMCBj8A3KKa gppqQ8Saz6kdzMZzeKL8phlWbqDrZpe0S5/TTy9Wx//aAAgBAQEGPwD8mpljoG1BG8WWmIstMRZa YhKQpMC5CgkjfAdByclDuvOA6LyclDuvOAKozD4L6gE7mLbfUxbaRi20jFAlGADrqSD7+D//2Q=="
                        transform="matrix(.48 0 0 -.48 9.304 20.977)"
                        overflow="visible"
                    />
                </g>
            </g>
            <path d="M11.5 32.9c.3 0 .7-.1 1-.3L27 24.3l-14.5 8.2c-.4.2-.7.3-1 .4m-1.1-.4" />
            <defs>
                <path id="PlayStoreSvgSVGID_17_" d="M27 24.3l.1-.1-.1.1" />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_18_">
                <use xlinkHref="#PlayStoreSvgSVGID_17_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_18_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_19_" d="M27 24.2h.1v.1H27z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_20_">
                    <use xlinkHref="#PlayStoreSvgSVGID_19_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_20_)">
                    <image
                        width={8}
                        height={4}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF5AAABhgAAAbD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAYACgMBIgACEQEDEQH/ xABtAAEBAQAAAAAAAAAAAAAAAAAAAgYBAQAAAAAAAAAAAAAAAAAAAAEQAAIDAQAAAAAAAAAAAAAA AAABESECEhEBAAICAwAAAAAAAAAAAAAAAREhEFHBAhISAQADAAAAAAAAAAAAAAAAAAAxQWH/2gAM AwEAAhEDEQAAAN9QP//aAAgBAgABBQC5/9oACAEDAAEFAD//2gAIAQEAAQUAb30f/9oACAECAgY/ ALnH/9oACAEDAgY/AH//2gAIAQEBBj8AAB6X6Zs1BHOP/9k="
                        transform="matrix(.48 0 0 -.48 25.599 25.571)"
                        overflow="visible"
                    />
                </g>
            </g>
            <defs>
                <path
                    id="PlayStoreSvgSVGID_21_"
                    d="M11.4 32.9c-.3 0-.6-.1-.9-.3l-.1-.1.1-.1c.2.2.5.3.9.3.3 0 .7-.1 1.1-.3L27 24.1l.1.1-.1.1-14.5 8.2c-.4.2-.7.3-1.1.4.1 0 0 0 0 0"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_22_">
                <use xlinkHref="#PlayStoreSvgSVGID_21_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_22_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_23_" d="M10.4 24.1h16.7v8.7H10.4z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_24_">
                    <use xlinkHref="#PlayStoreSvgSVGID_23_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_24_)">
                    <image
                        width={40}
                        height={22}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHTAAACCwAAAq7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABcAKgMBIgACEQEDEQH/ xACXAAACAwEBAAAAAAAAAAAAAAAABQECBgcEAQEBAAMAAAAAAAAAAAAAAAADAgABBRAAAQMBBwUA AAAAAAAAAAAAAAEDBRICEwQUFQYWESEiJDURAAIBAgIJBQAAAAAAAAAAAAECAwAEEdEQIbESMpIT NJQgQSJCcxIAAQQBBAMBAAAAAAAAAAAAEQABAhJBITETM1GRoUP/2gAMAwEAAhEDEQAAAHCuyOOw 7Esw2j2POejYORThZ2kIX17gNl//2gAIAQIAAQUAVe62lKlpWnqtB4U//9oACAEDAAEFAMOw1aay zJcNZhnNXfuntX//2gAIAQEAAQUA3HPyMdIcvmTl0yctmCN3NKYnHm8vrogiCIQ31TdEfbxMlo7h o7ho7hFxdtqRP//aAAgBAgIGPwBbonK1Kysgr//aAAgBAwIGPwCDvCLu8dwuuHpNGkRxO4GbMoU4 q10JK/H6m6r8b+RUr//aAAgBAQEGPwAW9sUEZjVvkuJxJbKuKPkFcUfIK4o+QVbwSsnTlkVWwUA4 E6F/FNrei0/VNugSCeCMdJRuyyrG2ot9WNd1aeRHnXdWnkR513Vp5CZ1bSG4tmCyKd1JkZjgfYA6 9H//2Q=="
                        transform="matrix(.48 0 0 -.48 9.285 34.018)"
                        overflow="visible"
                    />
                </g>
            </g>
            <path d="M10.4 32.5c-.3-.3-.5-.8-.5-1.4.1.6.2 1.1.5 1.4" />
            <defs>
                <path
                    id="PlayStoreSvgSVGID_25_"
                    d="M10.4 32.5c-.3-.3-.5-.8-.5-1.4V31c0 .6.2 1.1.5 1.4v.1"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_26_">
                <use xlinkHref="#PlayStoreSvgSVGID_25_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_26_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_27_" d="M10 30.9h.5v1.6H10z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_28_">
                    <use xlinkHref="#PlayStoreSvgSVGID_27_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_28_)">
                    <image
                        width={8}
                        height={7}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGGAAABlAAAAcX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/ xAB3AAEBAQAAAAAAAAAAAAAAAAAABAYBAQEAAAAAAAAAAAAAAAAAAAIDEAABBQEAAAAAAAAAAAAA AAAREAISIgQjEQACAQUBAAAAAAAAAAAAAAARAhIgMUEDEwQSAAAEBwAAAAAAAAAAAAAAAAABEVEx cYGhMoIT/9oADAMBAAIRAxEAAADcUCn/AP/aAAgBAgABBQCo/9oACAEDAAEFAOh//9oACAEBAAEF AH6Y61//2gAIAQICBj8A1uP/2gAIAQMCBj8AiadGLFJvUf/aAAgBAQEGPwDX5onorPI2jgCj/9k="
                        transform="matrix(.48 0 0 -.48 8.685 33.758)"
                        overflow="visible"
                    />
                </g>
            </g>
            <defs>
                <path id="PlayStoreSvgSVGID_29_" d="M10.4 32.5l.1-.1-.1.1" />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_30_">
                <use xlinkHref="#PlayStoreSvgSVGID_29_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_30_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_31_" d="M10.4 32.4h.1v.1h-.1z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_32_">
                    <use xlinkHref="#PlayStoreSvgSVGID_31_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_32_)">
                    <image
                        width={8}
                        height={4}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF0AAABgQAAAar/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAYACgMBIgACEQEDEQH/ xABoAAEBAQAAAAAAAAAAAAAAAAAAAgYBAQEAAAAAAAAAAAAAAAAAAAABEAEBAQEAAAAAAAAAAAAA AAAAAQISEQEAAgMBAAAAAAAAAAAAAAABESEQQRLBEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIR AxEAAADfUL//2gAIAQIAAQUAf//aAAgBAwABBQB//9oACAEBAAEFAJd9P//aAAgBAgIGPwB//9oA CAEDAgY/AH//2gAIAQEBBj8ARDmuWbXcke4//9k="
                        transform="matrix(.48 0 0 -.48 9.286 33.662)"
                        overflow="visible"
                    />
                </g>
            </g>
            <path d="M32.9 20.5c.1-.2.1-.3.1-.5.1.2 0 .3-.1.5" />
            <defs>
                <path
                    id="PlayStoreSvgSVGID_33_"
                    d="M27.1 24.2l4.9-2.9c.6-.4 1-.8 1-1.3 0 .2 0 .3-.1.5-.2.3-.5.7-.9.9l-4.9 2.8"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_34_">
                <use xlinkHref="#PlayStoreSvgSVGID_33_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_34_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_35_" d="M27 20h6v4.2h-6z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_36_">
                    <use xlinkHref="#PlayStoreSvgSVGID_35_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_36_)">
                    <image
                        width={20}
                        height={13}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGjAAABwgAAAij/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AFwMBIgACEQEDEQH/ xACIAAACAwEAAAAAAAAAAAAAAAAABQIDBAYBAQEBAAAAAAAAAAAAAAAAAAQDBRAAAQQCAwAAAAAA AAAAAAAAAgABAwQSBREhFBEAAQMCBAcAAAAAAAAAAAAAEQECEgAxQdEyAyHhUpIzkwQSAAAFAwUA AAAAAAAAAAAAAAABESESMXECUaFiAxP/2gAMAwEAAhEDEQAAAO0zTX5KHRWPj//aAAgBAgABBQC3 JeGbmXy//9oACAEDAAEFAAGLDrP/2gAIAQEAAQUAv3nqJtyTqOy51NvEUiaqagB21v8A/9oACAEC AgY/AMy6S7INGOClR3QSf18Vo846XH//2gAIAQMCBj8AKSLccZbD/9oACAEBAQY/ANsMnM4gAZ14 k7uVL9MQqNc6J6TlWyHNaJanI28bSWte37G50rC0wehRUVvGWNq//9k="
                        transform="matrix(.48 0 0 -.48 25.704 25.42)"
                        overflow="visible"
                    />
                </g>
            </g>
            <path
                className="PlayStoreSvgst11"
                d="M33.1 20c0-.5-.4-1-1-1.4l-4.9-2.8 4.9 2.8c.6.4 1 .9 1 1.4"
            />
            <defs>
                <path
                    id="PlayStoreSvgSVGID_37_"
                    d="M33.1 20c-.1-.5-.4-.9-1-1.3l-5-2.8.1-.1 4.9 2.8c.6.4 1 .9 1 1.4"
                />
            </defs>
            <clipPath id="PlayStoreSvgSVGID_38_">
                <use xlinkHref="#PlayStoreSvgSVGID_37_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#PlayStoreSvgSVGID_38_)">
                <defs>
                    <path id="PlayStoreSvgSVGID_39_" d="M27 15.8h6V20h-6z" />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_40_">
                    <use xlinkHref="#PlayStoreSvgSVGID_39_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_40_)">
                    <image
                        width={20}
                        height={13}
                        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGhAAABuwAAAgf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AFwMBIgACEQEDEQH/ xACHAAACAwAAAAAAAAAAAAAAAAAAAwEEBgEBAQEAAAAAAAAAAAAAAAAAAwQFEAABBAIDAQAAAAAA AAAAAAADAAECBBITESEjFBEAAQMDAgcAAAAAAAAAAAAAAQARAiESMjFBUWFxoSKSExIAAQMCBwAA AAAAAAAAAAAAEgAREwEhMUFhgaHRAv/aAAwDAQACEQMRAAAA3KWIzHtkFpf/2gAIAQIAAQUAsvc2 +nz/AP/aAAgBAwABBQCGvHrP/9oACAEBAAEFALJ5BTXSOokeQbg80wFCPFf/2gAIAQICBj8A9RGF malsFnJFuY9r/9oACAEDAgY/AKEzrQuF/9oACAEBAQY/AI2gG59eSxHdfRqsS3RQ8oxZ8i3BZw9l a40NXpuv/9k="
                        transform="matrix(.48 0 0 -.48 25.704 21.302)"
                        overflow="visible"
                    />
                </g>
            </g>
            <path
                className="PlayStoreSvgst11"
                d="M10 8.8c.1-1 .6-1.6 1.4-1.6-.3 0-.6.1-.9.3l-.1.1c-.2.2-.4.6-.4 1.2"
            />
            <g>
                <defs>
                    <path
                        id="PlayStoreSvgSVGID_41_"
                        d="M10 9.1v-.2-.2c0-.5.2-.9.5-1.2l.1.1c-.4.3-.6.8-.6 1.5m.5-1.6"
                    />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_42_">
                    <use xlinkHref="#PlayStoreSvgSVGID_41_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_42_)">
                    <defs>
                        <path id="PlayStoreSvgSVGID_43_" d="M10 7.5h.5v1.6H10z" />
                    </defs>
                    <clipPath id="PlayStoreSvgSVGID_44_">
                        <use xlinkHref="#PlayStoreSvgSVGID_43_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#PlayStoreSvgSVGID_44_)">
                        <image
                            width={8}
                            height={7}
                            xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGDAAABkQAAAb//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAgACgMBIgACEQEDEQH/ xAB1AAEBAQAAAAAAAAAAAAAAAAAAAwYBAQEAAAAAAAAAAAAAAAAAAAIDEAABBAMAAAAAAAAAAAAA AAARAAEhAiIDBBEAAgEFAAAAAAAAAAAAAAAAAQIQESExQSMSAAEDBQAAAAAAAAAAAAAAAAARQbGh wTJCM//aAAwDAQACEQMRAAAA3Vhy/9oACAECAAEFAIH/2gAIAQMAAQUAyP8A/9oACAEBAAEFALX2 t0L/2gAIAQICBj8AbG8n/9oACAEDAgY/ANulEg//2gAIAQEBBj8ARAvIqSzUwdXj/9k="
                            transform="matrix(.48 0 0 -.48 8.685 10.064)"
                            overflow="visible"
                        />
                    </g>
                </g>
            </g>
            <path className="PlayStoreSvgst11" d="M11.4 7.1" />
            <g>
                <defs>
                    <path
                        id="PlayStoreSvgSVGID_45_"
                        d="M27 15.9L12.5 7.6c-.4-.2-.8-.3-1.1-.3-.3 0-.6.1-.9.3l-.1-.1.1-.1c.2-.2.5-.3.9-.3.3 0 .7.1 1.1.3L27 15.9"
                    />
                </defs>
                <clipPath id="PlayStoreSvgSVGID_46_">
                    <use xlinkHref="#PlayStoreSvgSVGID_45_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#PlayStoreSvgSVGID_46_)">
                    <defs>
                        <path id="PlayStoreSvgSVGID_47_" d="M10.4 7.1h16.7v8.7H10.4z" />
                    </defs>
                    <clipPath id="PlayStoreSvgSVGID_48_">
                        <use xlinkHref="#PlayStoreSvgSVGID_47_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#PlayStoreSvgSVGID_48_)">
                        <image
                            width={40}
                            height={22}
                            xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHOAAAB/QAAAoX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABcAKgMBIgACEQEDEQH/ xACVAAACAgMAAAAAAAAAAAAAAAAABAUGAQIDAQEBAQEBAAAAAAAAAAAAAAADAQIEBRAAAQMCBwEB AAAAAAAAAAAABAABAxEUAhIiEyQFFRA0EQEAAQICCAcAAAAAAAAAAAABAgADEBFBkbESMnKSMyAh MVFxIhMSAAEDAwQDAAAAAAAAAAAAAAEAAhIRIRMxQQMzcZJD/9oADAMBAAIRAxEAAAC2rbJF4jYq QX5ev2CtErBroyBkesyFX//aAAgBAgABBQDE71zOqvlfLXQtNP/aAAgBAwABBQAmabDNcTrfltp7 Tc4C4ex//9oACAEBAAEFAOwNIgn9MxemYvTMQ/YFSTrtn5f0P9S7IZ5SWCdWbqzdDCvhIX//2gAI AQICBj8AN1qVrurrdb6r/9oACAEDAgY/AHgcjwA6wDiuzk9ii7I+WYCsr0iU6eSVb0X1R7IZB5lR f//aAAgBAQEGPwDctyCO6PoPvXGaiuM1FcZqKtwlIYykD5GByG18FrmNuBIuW4fUMpyIunRXes9Z Xes9ZXes9ZVuX62nKQ5ExX4w/9k="
                            transform="matrix(.48 0 0 -.48 9.285 17.023)"
                            overflow="visible"
                        />
                    </g>
                </g>
            </g>
            <path
                className="PlayStoreSvgst1"
                d="M43.7 13h-.8V7.7h-1.7V7h4.2v.7h-1.7V13z"
            />
            <path
                className="PlayStoreSvgst1"
                d="M43.7 13v-.1H43V7.6h-1.7v-.5h4v.5h-1.7V13h.1v-.1.1h.1V7.8h1.7v-.9h-4.4v.9h1.7v5.3h1V13h-.1zM49.8 7.7h-2.7v1.9h2.5v.8h-2.5v1.9h2.7v.7h-3.5V7h3.5v.7z"
            />
            <path
                className="PlayStoreSvgst1"
                d="M49.8 7.7v-.1H47v2.1h2.5v.6H47v2.1h2.7v.5h-3.3V7.1h3.3v.6h.1v-.1.1h.1V6.9h-3.7v6.2h3.7v-.9h-2.7v-1.7h2.5v-1h-2.5V7.8h2.7v-.1h-.1zM51.8 9.8H53c.3 0 .6-.1.8-.3.2-.2.3-.5.3-.8 0-.3-.1-.5-.3-.7-.2-.2-.5-.3-.8-.3h-1.3v2.1h.1zM51 13V7h2c.5 0 .9.2 1.3.5.5.3.7.8.7 1.3 0 .4-.1.8-.4 1.1-.3.3-.6.5-1 .6l1.7 2.4h-.9l-1.6-2.4h-.9V13H51z"
            />
            <path
                className="PlayStoreSvgst1"
                d="M51.8 9.8l1.2.1c.3 0 .6-.1.9-.3.2-.2.4-.5.4-.8 0-.3-.1-.6-.3-.8-.2-.2-.5-.4-.9-.4H51.7v2.3l.1-.1.1-2h1.2c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3h-1.3zM51 13h.1V7.1H53c.5 0 .9.2 1.3.5s.5.7.5 1.2c0 .4-.1.7-.4 1-.3.3-.6.5-1 .6v.2l1.7 2.5h.1V13h-.9l-1.6-2.4h-1V13H51h.1-.1l.8.1h.1v-2.4h.7l1.6 2.4h1.1V13l-1.7-2.5-.1.1.1.1-.1-.1v.1c.4-.1.8-.3 1.1-.6.3-.3.4-.7.4-1.2s-.2-1-.6-1.4C54 7.1 53.5 7 53 7h-2.1l.1 6zM57.3 10.7h2l-1-2.7-1 2.7zM55.6 13l2.3-6h.9l2.3 6h-.9l-.6-1.6H57l-.6 1.6h-.8z"
            />
            <path
                className="PlayStoreSvgst1"
                d="M57.3 10.7l2.1.1-1.1-2.9h-.2L57 10.8l.3-.1 1-2.7h-.1v-.1h-.1l.9 2.6h-1.9v.2h.2zM55.6 13l2.3-5.9h.7l2.2 5.8h-.6l-.6-1.6h-2.7l-.6 1.6h-.8v.1h.1l.9.1h.1l.6-1.6h2.4l.6 1.6h.9l-2.3-6.2h-1l-2.3 6.2.1-.1zM61.5 13v-.8l3.2-4.5h-3.1V7h4v.8l-3.2 4.5h3.2v.7h-4.1z"
            />
            <path
                className="PlayStoreSvgst1"
                d="M61.5 13h.1v-.8l3.3-4.6h-3.2v-.5h3.8v.7l-3.3 4.6h3.3v.5h-4v.1h.1-.1v.1h4.2v-.9h-3.1l3.1-4.4v-.9h-4.2v.9h3l-3.1 4.4v.9h.1V13zM68.7 13V7h1l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13h-.8z"
            />
            <path
                className="PlayStoreSvgst1"
                d="M68.7 13h.1V7.1h.8l2.9 4.7h.2V7.1h.6v5.8h-.7l-3-4.9h-.2v4.9h-.7v.1h.1-.1v.1h.9v-5h-.1v.1-.1l-.1.1 3.1 4.9h1V6.9h-1v4.8h.1v-.1.1l.1-.1-3-4.7h-1.1v6.2h.1V13zM75.9 10.7h2l-1-2.7-1 2.7zM74.2 13l2.3-6h.9l2.3 6h-.9l-.6-1.6h-2.5l-.6 1.6h-.9z"
            />
            <path
                className="PlayStoreSvgst1"
                d="M75.9 10.7l2.1.1-1-3h-.2l-1.1 2.9h.2L77 8h-.1v-.1h-.1l.9 2.6h-1.9v.2h.1zM74.2 13l2.3-5.9h.7l2.2 5.8h-.6l-.6-1.6h-2.7l-.5 1.6h-.8v.1l.9.1h.1l.6-1.6h2.4l.6 1.6h1l-2.3-6.2h-1l-2.3 6.2V13z"
            />
        </svg>
    )
}

export default PlayStoreSvg
